module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/dashboard/FullScreenMessage.ejs -->\n<div class="wrapper wrapper-content">\n    <div id="full-screen-message" style="pointer-events: none;">\n        <div class="fsm-container-1">\n            <div class="fsm-container-2">\n                ';
 if (isAddEmployee) { 
__p+='\n                    <img src="/images/Addempl.png">\n                    <h2>\n                        You need to add <b>at least one</b> employee\n                        before you can Run Payroll\n                    </h2>\n                    <a class="btn btn-primary btn-large"\n                       href="#employee/add"\n                       style="pointer-events: initial;">\n                        Add Employee\n                    </a>\n                ';
 } else if (isSetupCompany) { 
__p+='\n                    <img src="/images/start.png">\n                    <h2>\n                        <b>Let\'s start</b> by setting up your company with a\n                        short form\n                    </h2>\n                    <a class="btn btn-primary btn-large"\n                       href="#settings/company"\n                       style="pointer-events: initial;">\n                        Company Setup\n                    </a>\n                ';
 } 
__p+='\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/dashboard/FullScreenMessage.ejs
// module id = 1014
// module chunks = 1